import React, {useMemo} from 'react';

import {Node, opPick, constString} from '@wandb/cg';

import * as CGReact from '../../cgreact';
import {PanelBankSectionConfig} from '../WeavePanelBank/panelbank';
import {ChildPanel, ChildPanelFullConfig} from './ChildPanel';
import * as Panel2 from './panel';

/// Wow, so simple. This should be called PanelLayoutSections...
// damn.

type PanelLayoutBankConfig = {
  pbConfig: PanelBankSectionConfig;
  panel: ChildPanelFullConfig;
};

// const inputType = 'any' as const;
const inputType = {
  type: 'list' as const,
  objectType: {
    type: 'typedDict' as const,
    propertyTypes: {
      name: {
        type: 'union' as const,
        members: ['string' as const, 'number' as const, 'none' as const],
      },
      panels: 'any' as const,
    },
  },
};

type PanelLayoutBankProps = Panel2.PanelProps<
  typeof inputType,
  PanelLayoutBankConfig
>;

export const PanelLayoutBankConfigComp: React.FC<PanelLayoutBankProps> =
  props => {
    return <div>No config yet</div>;
  };

const PanelLayoutBankItem: React.FC<PanelLayoutBankProps & {item: Node}> =
  props => {
    const {item} = props;
    console.log('ITEM TYPE', item);
    const nameNode = useMemo(
      () => opPick({obj: item, key: constString('name')}),
      [item]
    );
    const nameQuery = CGReact.useNodeValue(nameNode);
    return (
      <div>
        <div>Name: {nameQuery.result}</div>
        <ChildPanel
          config={{
            id: 'LayoutFlow',
            input_node: opPick({obj: item, key: constString('panels')}),
            config: props.config,
            vars: {},
          }}
          updateConfig={(newConfig: ChildPanelFullConfig) => {
            throw new Error('Function not implemented.');
          }}
        />
      </div>
    );
  };

export const PanelLayoutBank: React.FC<PanelLayoutBankProps> = props => {
  console.log('PANEL LAYOUT BANK TYPE', props.input.type);
  const sectionNodes = CGReact.useEach(props.input as any);
  return (
    <div>
      {sectionNodes.result.map(node => (
        <PanelLayoutBankItem {...props} item={node} />
      ))}
    </div>
  );
};

export const Spec: Panel2.PanelSpec = {
  id: 'LayoutBank',
  ConfigComponent: PanelLayoutBankConfigComp,
  Component: PanelLayoutBank,
  inputType,
  // hidden: true,
};
